import { render, staticRenderFns } from "./TreatmentIndication.vue?vue&type=template&id=5fff6be6&scoped=true&lang=pug&"
import script from "./TreatmentIndication.vue?vue&type=script&lang=js&"
export * from "./TreatmentIndication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff6be6",
  null
  
)

export default component.exports